module.exports = __webpack_public_path__ + "img/avatar_19.ac2cbf12.svg";